//List des documents achetés
export const DOCUMENTS_LIST_REQUESTING = 'DOCUMENTS_LIST_REQUESTING'
export const DOCUMENTS_LIST_SUCCESS = 'DOCUMENTS_LIST_SUCCESS'
export const DOCUMENTS_LIST_FAILED = 'DOCUMENTS_LIST_FAILED'

export const PAGINATE_DOCUMENTS_LIST_REQUESTING = 'PAGINATE_DOCUMENTS_LIST_REQUESTING'
export const PAGINATE_DOCUMENTS_LIST_SUCCESS = 'PAGINATE_DOCUMENTS_LIST_SUCCESS'
export const PAGINATE_DOCUMENTS_LIST_FAILED = 'PAGINATE_DOCUMENTS_LIST_FAILED'

